module.exports = __webpack_public_path__ + "static/media/Corona-Hinweis-Kl4.9b0a91f9.jpg";